<template>
  <v-btn
    @click="toggleDarkMode"
    depressed
    dark
    height="2rem"
    color="backgroundWhite"
  >
    <v-icon color="titleLight">
      {{ isDarkMode ? "mdi-white-balance-sunny" : "mdi-weather-night" }}
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: "ThemeVT",
  mounted() {
    this.$vuetify.theme.dark = this.$store.state.darkMode;
    this.toggleBodyColor();
  },
  methods: {
    toggleDarkMode() {
      this.$store.commit("set_dark_mode", !this.$store.state.darkMode);
      this.$vuetify.theme.dark = this.$store.state.darkMode;
      this.toggleBodyColor();
    },
    toggleBodyColor() {
      document.body.setAttribute(
        "data-theme",
        this.$store.state.darkMode ? "dark" : "light"
      );
    },
  },
  computed: {
    isDarkMode() {
      return this.$store.state.darkMode;
    },
  },
};
</script>
